import React, { useState } from 'react';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import Modal, { ModalButton } from '../../../ui/Modal';

const ChangingModalDateofDeliveryOrders = ({ onClose, onConfirm }) => {
  const [newDate, setNewDate] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (!newDate) { setError('Выберите дату'); return; }
    onConfirm(newDate);
    onClose();
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Изменить дату доставки"
      subtitle="Новая дата применится ко всем выбранным заказам"
      size="sm"
      footer={
        <>
          <ModalButton variant="ghost" onClick={onClose}>Отмена</ModalButton>
          <ModalButton variant="primary" onClick={handleSubmit} disabled={!newDate}>
            <EventOutlinedIcon sx={{ fontSize: 18 }} />
            Применить
          </ModalButton>
        </>
      }
    >
      <div className="uimodal-field" style={{ gridTemplateColumns: '1fr', paddingTop: 0 }}>
        <label className="uimodal-field__label">Новая дата доставки</label>
        <input
          type="date"
          value={newDate}
          onChange={(e) => {
            const raw = e.target.value;
            if (!raw) { setNewDate(''); return; }
            const corrected = new Date(raw);
            corrected.setDate(corrected.getDate() + 1);
            setNewDate(corrected.toISOString().split('T')[0]);
            setError('');
          }}
          style={{
            width: '100%', height: 40, padding: '0 12px',
            border: `1px solid ${error ? '#DC4D45' : 'rgba(56,47,42,0.18)'}`,
            borderRadius: 8, fontFamily: 'inherit', fontSize: 13.5, background: '#fff', outline: 'none',
          }}
        />
      </div>
      {error && (
        <div style={{
          marginTop: 12, padding: '10px 12px',
          background: 'rgba(220,77,69,0.08)',
          border: '1px solid rgba(220,77,69,0.25)',
          color: '#B73C36', borderRadius: 8, fontSize: 13,
        }}>{error}</div>
      )}
    </Modal>
  );
};

export default ChangingModalDateofDeliveryOrders;
